import {styled} from "@mui/material/styles"
import { cssVarColors } from "../../../../Constants";
import {mobileThreshold, portfolioWidth} from "../../../../Constants/layoutValues";
import {SectionTitle} from "../../HomePageStyles";

export const EducationWrapper = styled('div')`
	padding-top: 2rem;
	padding-bottom: 2rem;
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
`;

export const Wrapper = styled('div')`
	width: 100%;
	max-width: ${portfolioWidth}px;
	padding-left: 1rem;
	padding-right: 1rem;
`;

export const Title = SectionTitle;

export const ContentWrapper = styled('div')`
	position: relative;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	gap: 2rem;
	padding-top: 2rem;
	padding-bottom: 1rem;
	
	&::before {
		content: '';
		position: absolute;
		top: 0.75rem;
		left: 0;
		right: 0;
		height: 2px;
		background-color: ${cssVarColors.highlight};
	}
	
	@media (max-width: ${mobileThreshold}px) {
		flex-direction: column;
		gap: 2rem;
		padding-left: 1rem;
		margin-left: 2rem;
		border-left: 2px solid ${cssVarColors.highlight};
		
		&::before {
			content: none;
		}
	}
`;

export const EducationEntryWrapper = styled('div')`
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: center;
	flex: 1 1 0;
	text-align: center;
	padding-top: 1.5rem;
	
	@media (max-width: ${mobileThreshold}px) {
		flex-direction: row;
		align-items: flex-start;
		padding-left: 1rem;
	}
`;

export const TimelineMarker = styled('div')`
	position: absolute;
	top: -25px;
	left: 50%;
	transform: translateX(-50%);
	width: 0.75rem;
	height: 0.75rem;
	background-color: ${cssVarColors.highlight};
	border-radius: 50%;
	
	@media (max-width: ${mobileThreshold}px) {
		position: absolute;
		left: -1.45rem;
		top: 50%;
		transform: translateY(-50%);
		margin-right: 0;
	}
`;
export const TimelineContent = styled('div')`
	display: flex;
	flex-direction: column;
	align-items: center;
	
	@media (max-width: ${mobileThreshold}px) {
		align-items: flex-start;
	}
`;

export const Degree = styled('div')`
	font-family: montserratSemiBold;
	font-size: 1.2rem;
	padding-bottom: 0.3rem;
`;

export const School = styled('div')`
	font-family: montserratItalics;
	font-size: 1.1rem;
	padding-bottom: 0.2rem;
`;

export const Speciality = styled('div')`
	font-family: montserrat;
	font-size: 1rem;
	line-height: 1.5;
	@media (max-width: ${mobileThreshold}px)
	{
		text-align: left;
	};
`;
